import axiosInstance from "../utils/authUtils";
import { API_PATHS ,API_BASE_URL} from "../utils/constants/api.constants";

class PropertyTypeService {
  static getPropertyType(item) {
  
      let api = '';
      if(item?.id){
         api= `${API_BASE_URL}${API_PATHS.getpropertytype}?id=${item?.id}`
      } else{
      api = `${API_BASE_URL}${API_PATHS.getpropertytype}?limit=${item?.limit}`;
      }
      return axiosInstance
          .get(api)
          
  }

  
static addPropertyType(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.addpropertytype}`;
    return axiosInstance
        .post(api,item)
        
}

static editPropertyType(item) {
  
    let api = '';
    api = `${API_BASE_URL}${API_PATHS.editpropertytype}`;
    return axiosInstance
        .put(api,item)
        
}

static deletePropertyType(item) {
  
    let api = '';
    if(item?.id){
        api = `${API_BASE_URL}${API_PATHS.deletepropertytype}?id=${item?.id}`;
    }else{
        api = `${API_BASE_URL}${API_PATHS.deletepropertytype}`;
    }
    
    return axiosInstance
        .delete(api)
        
}


  
}

export default PropertyTypeService;